module.exports = __webpack_public_path__ + "static/help-center-deeba8bca9ddeecf373c9b3e527830c3.png";